import styled from 'styled-components';

import { SelectIdField } from '~fields';
import { usePatientRooms } from '~hooks/usePatientRooms';

const RoomFields = ({
  setExternalValidations,
  formik: { setFieldValue, values },
}) => {
  const patientRooms = usePatientRooms();

  const { room } = values;
  const patientRoomOptions = patientRooms.map(room => ({
    label: room.clinicalName,
    value: room.id,
  }));

  const selectedRoom = room ? patientRooms.find(r => r.id === room) : null;
  const locationOptions = selectedRoom?.bedPlaces.map(location => ({
    label: location.clinicalName,
    value: location.id,
  }));

  const handleRoomChange = room => {
    setFieldValue('location', null);

    const selectedRoom = patientRooms.find(r => r.id === room);
    const requireRoom = selectedRoom?.bedPlaces.length > 0;
    if (requireRoom) {
      setExternalValidations([
        {
          name: 'location',
          getError: value => (value ? undefined : 'Vaadittu'),
        },
      ]);
    } else {
      setExternalValidations([]);
    }
  };

  return (
    <LocationWrapper>
      <SelectIdField
        name="room"
        options={patientRoomOptions}
        fallbackPlaceholder="Valitse..."
        onChange={handleRoomChange}
        required
      />
      <SelectIdField
        name="location"
        options={locationOptions}
        fallbackPlaceholder="Valitse..."
        disabled={!room || !locationOptions.length}
        required={!room || locationOptions.length}
      />
    </LocationWrapper>
  );
};

const LocationWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  & > div {
    flex-basis: 100%;
  }
`;

export default RoomFields;
